import { render, staticRenderFns } from "./dataEntryTable.vue?vue&type=template&id=a92b9fa2&scoped=true"
import script from "./dataEntryTable.vue?vue&type=script&lang=js"
export * from "./dataEntryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92b9fa2",
  null
  
)

export default component.exports